export const LIBRARY_FEATURE_KEY = 'library';
